/**
 *
 * @component 用户中心/我的消息/----消息组件
 *
 **/

import './MessageItem.scss';

const MessageItem = props => {
    const {
        data,
        deleteMsg,
        content,
        onClick = () => {},
        disabled = false,
    } = props;

    return (
        <section className="message-item" onClick={onClick}>
            <i
                className={`icon-bell filled read-icon ${
                    data.status === 2 ? 'unred' : ''
                }`}
            />
            <div className="message-main">
                <div className="message-content">{content}</div>
                <div className="message-aside">
                    <div className="time">
                        {data.hourMin || data.createDate}
                    </div>
                    <i
                        className={`text-btn filled icon-trash${
                            disabled ? ' type--disabled' : ''
                        }`}
                        onClick={e => !disabled && deleteMsg(e, data.id)}
                    />
                </div>
            </div>
        </section>
    );
};
export default MessageItem;
